(function () {
  'use strict';

  /* @ngdoc service
   * @name itecAdministracio.permisos.categories:rolsHeaderSubmenuLinks
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols')
    .value('permisosRolsHeaderSubmenuLinksValue',  {
      'name'     : 'rols.main',
      'addPermit'    : 'AFEGIRROL',
      'options'  : {
          '0': {
            'name'         : 'DEFAULT_DADES_GENERALS',
            'state'        : 'rols.main.submain.dades',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'ROL',
            'stateOptions' : {'reload': 'rols.main.submain'}
          },
          '1': {
            'name'         : 'DEFAULT_ROLS_PERMISOS',
            'state'        : 'rols.main.submain.permisos',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'ROL',
            'stateOptions' : {'reload': 'rols.main.submain'}
          }
      }
    });
}());
